import { KeyRound, LoaderCircle, Mail, ShieldCheck } from 'lucide-react'
import { useState } from 'react'
import { adminEmail, supabase } from '../lib/supabase'

export function AuthGate() {
  const [email, setEmail] = useState(adminEmail)
  const [state, setState] = useState<'idle' | 'sending' | 'sent' | 'error'>('idle')
  const [message, setMessage] = useState('')
  const send = async () => {
    if (!supabase || !email.trim()) return
    setState('sending')
    const { error } = await supabase.auth.signInWithOtp({
      email: email.trim(), options: { emailRedirectTo: window.location.origin },
    })
    if (error) { setState('error'); setMessage(error.message) } else setState('sent')
  }
  return <main className="auth-screen"><section className="auth-card">
    <div className="auth-logo"><ShieldCheck /></div><span className="eyebrow">HDM Trend Intelligence</span>
    <h1>Private, invitation-only access</h1>
    <p>Enter an invited email. We send a secure sign-in link—there is no password to remember.</p>
    {state === 'sent' ? <div className="auth-success"><Mail /><strong>Check your email</strong><span>The secure link will return you to this dashboard.</span></div> : <>
      <label>Email address<input type="email" value={email} onChange={(event) => setEmail(event.target.value)} /></label>
      <button className="button primary" onClick={send} disabled={state === 'sending'}>{state === 'sending' ? <LoaderCircle className="spin" /> : <KeyRound />} Email me a secure link</button>
      {state === 'error' && <div className="auth-error">Could not send the link: {message}</div>}
    </>}
    <small>Only invited addresses can view HDM data. Only the owner can change product settings.</small>
  </section></main>
}
